import Footer from '../components/footer'
import navBar from '../components/navBar'

const Cooperative = ()=>{
    return(
        <>
        <navBar />
        
        <div className="container" style={{height:"10rem", marginTop:"15rem"}}>
            <h2>Cooperative Section Coming Soon</h2>
        </div>
        <Footer />
        </>
    )
}

export default Cooperative;